export function getVehicleImageUrl(vehicle) {
  if (!vehicle.picture) return null;
  if (vehicle.pictureSource === "upload") {
    return `https://app.autocrescente.com/WhyNotApi/uploads/vehicles/${vehicle.picture}`;
  }
  return `${process.env.PUBLIC_URL}/img_car/detail/${vehicle.picture}`;
}
